import { observable, action } from 'mobx'
import { actionBase } from 'wbap-core-commit'

class Model extends actionBase {

  constructor (appInfo, props) {
    super(appInfo)
    this.appInfo = appInfo
    this.props = props
  }

  @observable
  data = {
    DS_MA: {},
    dataTime: '',
    DS_NOTE: new Map()
  }

  componentDidMount () {
    this.actQuery.execute()
  }

  @action actQuery_onAfterExecute (target) {
    super.actQuery_onAfterExecute(target)
    const _data = this.model.tableJson('{005A5001-B9AD-41CB-8409-8F7675D19143}')
    if (_data.length === 0) {
      this.toast('error', '数据集为空!')
    } else {
      this.data.DS_MA = _data
      this.setDsNote()
      this.timeOutQuery()
      // this.setDsNote()
      // console.log(this.data.DS_MA)
      // console.log(this.data.DS_NOTE)
    }
  }

  @action setDsNote () {
    let visitData = []
    const _data = this.model.tableJson('{539BF364-32C3-4DE5-A34C-EFC354BD2A55}')
    if (_data.length === 0) return null
    this.data.DS_MA.forEach((itemMA) => {
      if (!this.data.DS_NOTE.has(itemMA.FKIND_NAME)) {
        _data.filter((item) => item.FKIND_NAME === itemMA.FKIND_NAME).forEach((item) => {
          let visitDataItem = {}
          visitDataItem.x = item.X
          visitDataItem.y = parseFloat(item.Y)
          visitData.push(visitDataItem)
        })
        this.data.DS_NOTE.set(itemMA.FKIND_NAME, visitData)
      }
    })
  }

  timeOutQuery () {
    console.log('componentWillReact')
    setTimeout(() => {
        this.actQuery.execute()
      },
      180000
    )
  }

  @action mainFull = () => {
    this.model.UIStore.headerDisplay = false
    this.model.UIStore.menuDisplay = false
    console.log(this.model.UIStore)
  }

}

export default Model




// WEBPACK FOOTER //
// ./src/wbap-unit-app/wbap-dashboard-dailyPrice/model.js